module.exports = __webpack_public_path__ + "static/media/logo-navbar-dark.86748397.svg";